












import { Vue, Component, Watch, Prop } from "@/shared/vuepack";

import { Location } from "vue-router";
import GeneralInformation from "./GeneralInfo.vue";
import PlanDetail from "./PlanDetail.vue";
import PayrollSetup from "./PayrollSetup.vue";
import Finish from "./Finish.vue";
import { ProfileWizardSteps } from "@/employer/types";
import { FetchState } from "@/shared/types";
import _ from "lodash";
import GenericLoadingSpinner from "@/shared/components/ui/GenericLoadingSpinner.vue";
import { useProfileStore } from "@/employer/store/profile";
import { useUserStore } from "@/shared/store/user";

@Component ({
  components: {
    generalinformation: GeneralInformation,
    plandetail: PlanDetail,
    payrollSetup: PayrollSetup,
    finish: Finish,
    GenericLoadingSpinner
  }
})
export default class Wizard extends Vue {
  profileStore = useProfileStore();
  userStore = useUserStore();

  validated = false;

  get employerId () { return this.forEmployerId || this.userStore.employerId; }

  get profileCurrentEmployerName () { return _.get(this.profileStore.employerInformation, "name", ""); }

  get isProfileEmployerLoaded () {
    return this.isSelfSignup
     ? true // don't actually need it then, so return true
     : this.profileStore.isEmployerInformationLoaded;
  }

  get employerName () {
    return this.isSelfSignup
    ? this.userStore.currentEmployerName
    : this.profileCurrentEmployerName;
  }

  @Prop()
  step: number;

  @Prop({required: false})
  forEmployerId: number;

  @Prop()
  goToStep: (step: number, edit: boolean) => Location;

  @Prop()
  routeToFinish: () => Location;

  @Prop()
  routeToWizardComplete: () => Location;

  @Prop({default: true})
  isSelfSignup: () => boolean;

  @Prop()
  partnerId: number;

  @Prop()
  edit: boolean;

  get isPartner () {
    return !!this.partnerId;
  }

  @Watch("step")
  onRouteValueStepChanged () {
    this.profileStore.setCurrentStep(this.step);
    this.validateStep();
  }

@Watch("profileStore.currentStep")
  onCurrentStepChanged () {
    this.routeIfValid(this.profileStore.currentStep);
  }

  created () {
    if (!this.employerId) {
      this.$router.push(this.routeToWizardComplete());
      return;
    }

    this.profileStore.getWizardState({employerId: this.employerId, edit: this.edit});

    if (!this.isSelfSignup && !this.profileCurrentEmployerName) {
      this.profileStore.loadProfileInformation(this.employerId);
    }

    if (this.isPartner) {
      this.validateStep();
      return;
    }

    if (this.profileStore.isOnboarded && !this.edit) { // No going back to wizard
      this.$router.push(this.routeToWizardComplete());
    } else {
      this.validateStep();
    }
  }

  validateStep () {
    if (isNaN(this.step)) {
      return;
    }

    if (this.step > this.profileStore.maxAllowedStep) {
      this.routeIfValid(this.profileStore.maxAllowedStep);
      return;
    }

    if (!(this.step in ProfileWizardSteps)) {
      this.routeIfValid(ProfileWizardSteps.GeneralInformation);
      return;
    }

    this.validated = true;
  }

  routeIfValid (stepNumber) {
    if (isNaN(stepNumber)) {
      this.$router.push(this.goToStep(this.profileStore.maxAllowedStep || ProfileWizardSteps.GeneralInformation, this.edit));
      return;
    }

    this.$router.push(this.goToStep(stepNumber, this.edit));
  }

  get showGeneralInformation () {
    return this.step === ProfileWizardSteps.GeneralInformation;
  }

  get showPlanDetail () {
    return this.step === ProfileWizardSteps.PlanDetail;
  }

  get showPayroll () {
    return this.step === ProfileWizardSteps.PayrollSetup;
  }

  get showFinish () {
    return this.step === ProfileWizardSteps.Finish;
  }

  get isLoaded () {
    return this.profileStore.wizardState === FetchState.Loaded && this.validated && this.isProfileEmployerLoaded;
  }

  cssClassName (stepNumber: number) {
    if (this.profileStore.maxAllowedStep < stepNumber) {
      return "todo";
    }
    else if (stepNumber === this.profileStore.maxAllowedStep) {
      return "current";
    } else {
      return "done";
    }
  }

  isNavigationEnabled (stepNumber: number) {
    if (this.profileStore.maxAllowedStep < stepNumber) {
      return false;
    }

    return true;
  }

  get isSelfSignupWizard () {
    return this.isSelfSignup;
  }
}
